import { get } from 'lodash';

export function getInstance(element, str = '') {
  let key = '';
  let instance = null;
  Object.keys(element).forEach((e) => {
    if (e.includes('reactInternalInstance')) {
      key = e;
    }
  });

  instance = get(
    element,
    '_reactRootContainer._internalRoot.current.child.child.child.child.stateNode'
  )
  ||
  _.get(
    element[key],
    'return.stateNode.ref'
  )
  ||
  _.get(
    element[key],
    str
  );

  return instance;
}


export function getInstanceAsync(element) {
  let key = '';

  if (!element) return;
  Object.keys(element).forEach((e) => {
    if (e.includes('reactInternalInstance')) {
      key = e;
    }
  });
  const instance = get(
    element,
    '_reactRootContainer._internalRoot.current.child.alternate.alternate.child.child.child.stateNode.targetComp'
  ) ||
  _.get(
    element[key],
    'return.stateNode.targetComp'
  );

  return instance || null;
}

